import React from 'react'
import Progress from './Progress'

const Analytics = () => {
  return (
    <div className="ana-bg">
      <h1 className='text-white text-center text-[50px]'>Techs Known</h1>
      <div className='flex justify-center'>

      <div className='flex-col items- justify-center m-[auto]' >
       <h1 className="text-white">HTML<Progress done="100"/></h1>
       <h1 className="text-white">Tailwin CSS<Progress done="100"/></h1>
       <h1 className="text-white">CSS<Progress done="100"/></h1>
       <h1 className="text-white">Bootstrap<Progress done="100"/></h1>
       <h1 className="text-white">Javascript<Progress done="75"/></h1>
       <h1 className="text-white">React JS<Progress done="75"/></h1>
       <h1 className="text-white">Python<Progress done="80"/></h1>
  </div>
      </div>

        </div>
    
  )
}

export default Analytics